import moment from 'moment';
import UserImg from '../assets/images/providerProfileImg.png'
import { fetchImg } from '../services/hireProvider.service';
import { FFmpeg } from '@ffmpeg/ffmpeg';

const ffmpeg = new FFmpeg();

export const convertToMp3 = async (webmBlob) => {
  if (!ffmpeg.loaded) await ffmpeg.load();

  const data = await webmBlob.arrayBuffer();
  ffmpeg.writeFile('input.webm', new Uint8Array(data));

  await ffmpeg.exec(['-i', 'input.webm', 'output.mp3']);

  const mp3Data = await ffmpeg.readFile('output.mp3');
  const mp3Blob = new Blob([mp3Data], { type: 'audio/mpeg' });

  return new File([mp3Blob], 'voice_note.mp3', { type: 'audio/mpeg' });
};

export const getFullName = (firstName, lastName) => {
  if (firstName && lastName) {
    return `${firstName} ${lastName}`;
  } else if (firstName) {
    return firstName;
  } else if (lastName) {
    return lastName;
  } else {
    return '';
  }
};

export const capitalizeFirstLetter = (inputString) => {
  if (typeof inputString !== 'string' || inputString.trim() === '') {
    return '';
  }

  return inputString.charAt(0).toUpperCase() + inputString.slice(1);
}

export const convertDateFormat = (utcDateString) => {

  // Format the local date/time as a string in the user's local timezone
  const formatLocalTime = (utcDate) => {
    return new Intl.DateTimeFormat('en-US', {
      day: '2-digit',
      month: 'long',
      year: 'numeric',
      hour12: true,
      hour: 'numeric',
      minute: '2-digit',
      timeZone: 'Atlantic/Bermuda' // Ensure this is the correct time zone for your use case
    }).format(utcDate);
  };

  // Convert the UTC date string to a moment object and check for validity
  const inputDate = moment.utc(utcDateString);

  if (!inputDate.isValid()) {
    console.error("Invalid date string:", utcDateString);
    return "Invalid date"; // Return a friendly message or handle it as needed
  }

  // Convert moment object to a JavaScript Date object for Intl.DateTimeFormat
  const localTime = formatLocalTime(inputDate.toDate());

  return localTime;
};


export const twoDecimalPlaces = (value) => {
  if (value == null) {
    return '';
  }

  const number = typeof value === 'string' ? parseFloat(value) : value;

  if (isNaN(number)) {
    return '';
  }

  // Round to two decimal places
  const roundedNumber = number.toFixed(2);

  return parseFloat(roundedNumber);
};

export const getCurrentISODateTime = () => {
  const currentTimeFormatted = moment().toISOString();
  return currentTimeFormatted;
};


// Image cache to avoid redundant API calls
const imageCache = new Map();
const CACHE_DURATION = 24 * 60 * 60 * 1000; // 24 hours

export const fetchImage = async (img) => {
  if (!img) return UserImg; // Return default image if `img` is null

  // Check cache first
  const cacheKey = img;
  const cached = imageCache.get(cacheKey);

  if (cached && Date.now() - cached.timestamp < CACHE_DURATION) {
    return cached.url;
  }

  try {
    const response = await fetchImg(img);
    const imageUrl = response?.data?.url || UserImg;

    // Cache the result
    imageCache.set(cacheKey, {
      url: imageUrl,
      timestamp: Date.now()
    });

    return imageUrl;
  } catch (error) {
    console.error("Error fetching image:", error);
    // Cache the fallback to avoid repeated failed requests
    imageCache.set(cacheKey, {
      url: UserImg,
      timestamp: Date.now()
    });
    return UserImg;
  }
};

// Clear old cache entries periodically
export const clearImageCache = () => {
  const now = Date.now();
  for (const [key, value] of imageCache.entries()) {
    if (now - value.timestamp > CACHE_DURATION) {
      imageCache.delete(key);
    }
  }
};

// Run cache cleanup every hour
if (typeof window !== 'undefined') {
  setInterval(clearImageCache, 60 * 60 * 1000);
}


export const getImageNameFromUrl = (url) => {
  try {
    const parsedUrl = new URL(url);
    const pathname = parsedUrl.pathname; // /1744200361479-download%20%281%29.jpeg
    const encodedFileName = pathname.substring(pathname.lastIndexOf("/") + 1);
    const decodedFileName = decodeURIComponent(encodedFileName); // ← decode here


    return decodedFileName;
  } catch (error) {
    console.error("Invalid URL passed:", url);
    return "";
  }
};


export function getUserTimeZoneOffset() {
  // return -180;
  // Check if the Intl.DateTimeFormat is supported
  if (window.Intl && typeof window.Intl === 'object') {
    // Get the user's time zone offset in minutes
    const userTimeZoneOffset = new Date().getTimezoneOffset();
    return userTimeZoneOffset;
  } else {
    // Fallback to a default time zone offset or handle the lack of Intl support as needed
    return 0; // Default to 0 offset (UTC)
  }
}


export const timeAgo = (createdDate) => {
  if (createdDate) {
    const timeDifference = moment(createdDate).fromNow();
    return <span>{timeDifference}</span>;
  } else {
    return ''
  }
};

export const getImageUrl = (imgName) => {
  const baseUrl = "http://54.201.160.69:9210/";
  const defaultImage = "serviceImg"; // Replace with your default image URL

  return imgName ? baseUrl + imgName : defaultImage;
}

// Function to convert base64 string to Blob
export function base64toBlob(base64Data, contentType) {
  const byteCharacters = atob(base64Data);
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);
  return new Blob([byteArray], { type: contentType });
}

export const formatTime = (timestamp) => {
  const date = new Date(timestamp);
  const currentDate = new Date();

  const timestampDate = date.getDate();
  const currentDay = currentDate.getDate();
  const currentMonth = currentDate.getMonth();
  const currentYear = currentDate.getFullYear();

  if (
    date < currentDate &&
    (date.getDate() !== currentDay ||
      date.getMonth() !== currentMonth ||
      date.getFullYear() !== currentYear)
  ) {
    // Timestamp is from a date before today
    const month = date.toLocaleString("default", { month: "short" });
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? "PM" : "AM";
    const formattedHours = hours % 12 || 12; // Handle midnight (0 hours)
    return `${month} ${timestampDate}, ${date.getFullYear()} ${formattedHours}:${minutes < 10 ? "0" : ""}${minutes} ${ampm}`;
  } else {
    // Timestamp is from today
    let hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours ? hours : 12; // Handle midnight (0 hours)
    return `${hours}:${minutes < 10 ? "0" : ""}${minutes} ${ampm}`;
  }
};

export const defaultShifts = [
  { dayOfWeek: 0, startTime: null, endTime: null, available: false }, // Sunday
  { dayOfWeek: 1, startTime: null, endTime: null, available: false }, // Monday
  { dayOfWeek: 2, startTime: null, endTime: null, available: false }, // Tuesday
  { dayOfWeek: 3, startTime: null, endTime: null, available: false }, // Wednesday
  { dayOfWeek: 4, startTime: null, endTime: null, available: false }, // Thursday
  { dayOfWeek: 5, startTime: null, endTime: null, available: false }, // Friday
  { dayOfWeek: 6, startTime: null, endTime: null, available: false }  // Saturday
];

// Function to convert an hour in 1-23 format to a JavaScript Date object
export const convertHourToDate = (hour, baseDate) => {
  // Ensure hour is within expected range
  if (hour < 0 || hour > 23) {
    throw new Error("Hour must be between 1 and 23.");
  }
  // Clone the base date to avoid mutating the original date
  let date = new Date(baseDate.getTime());
  date.setHours(hour, 0, 0, 0); // Set minutes, seconds, and milliseconds to 0
  return date;
};

 export const audioBlobToBase64 = (blob) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result); // base64 string
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  };
